// The light/dark switch for Cattle Market Central (owner, 2026-10-20: "light is default with a dark
// option"). Rendered on every page's masthead but shown only under [data-brand="cmc"] (the .cmc-only
// rule in cmc.base.css), so RaisedBeef never sees it. It holds no theme of its own: the theme is
// data-cmc-theme on <html>, set before the first render (initBrand.ts); this reads it after mount, so a
// prerendered page and its first client render agree.

import { useEffect, useState } from "react";

import { setTheme } from "./initBrand";

// Two copies can be on a page — the masthead button and, on phones, a row in the ☰ menu (owner,
// 2026-11-03: on a phone the switch sat on the logo). Each follows <html data-cmc-theme>, so flipping
// one turns the other with it.
export default function ThemeToggle({ variant = "icon" }: { variant?: "icon" | "menu" }) {
  const [dark, setDark] = useState(false);
  useEffect(() => {
    const read = () => setDark(document.documentElement.dataset.cmcTheme === "dark");
    read();
    const mo = new MutationObserver(read);
    mo.observe(document.documentElement, { attributes: true, attributeFilter: ["data-cmc-theme"] });
    return () => mo.disconnect();
  }, []);
  const flip = () => {
    const next = dark ? "light" : "dark";
    setTheme(next);
    setDark(next === "dark");
  };
  const icons = (
    <>
      <svg className="cmc-theme-sun" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
        <circle cx="12" cy="12" r="4.2" fill="none" stroke="currentColor" strokeWidth="2" />
        <path d="M12 2.5v2.6M12 18.9v2.6M2.5 12h2.6M18.9 12h2.6M5.3 5.3l1.8 1.8M16.9 16.9l1.8 1.8M5.3 18.7l1.8-1.8M16.9 7.1l1.8-1.8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      </svg>
      <svg className="cmc-theme-moon" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
        <path d="M20 14.5A8.5 8.5 0 0 1 9.5 4a8.5 8.5 0 1 0 10.5 10.5Z" fill="none" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
      </svg>
    </>
  );
  if (variant === "menu") {
    return (
      <button type="button" className="cmc-only cmc-theme-row" onClick={flip} aria-pressed={dark} aria-label="Dark theme">
        <span>{dark ? "Dark theme" : "Light theme"}</span>
        <span className="cmc-theme-row-sw">{icons}</span>
      </button>
    );
  }
  return (
    <button type="button" className="cmc-only cmc-theme" onClick={flip} aria-pressed={dark} aria-label="Dark theme" title={dark ? "Switch to the light theme" : "Switch to the dark theme"}>
      {icons}
    </button>
  );
}
